export const FileUploadConst = 
{
	key: "documents",
	label: "Dokümanlar",
	fileSize: "15728640",
	fileSizeText: "15MB",
	format: "PDF, PPTX, PPT"
};